import { render, staticRenderFns } from "./EditorShell.vue?vue&type=template&id=1590f224"
import script from "./EditorShell.vue?vue&type=script&lang=js"
export * from "./EditorShell.vue?vue&type=script&lang=js"
import style0 from "./EditorShell.vue?vue&type=style&index=0&id=1590f224&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports